import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  OverviewDialog,
  Table,
  DeactivateModal
} from '../../components';
import { LoadingSpinner } from '@parkhub/parkhub-ui';
import './People.scss';
import { getUsers, deactivateUser } from '../../actions/users.action';
import { sendRegistrationEmail } from '../../actions/registrationEmail.action';
import { clearAllFilters } from '../../actions/filter.action';

const peopleListLabelKeys = [
  { label: 'Name', key: 'displayName', sortable: true },
  { label: 'Email', key: 'contactString', sortable: true },
  { label: 'Role', key: 'role', sortable: true },
  { label: 'Organizations', key: 'organization', sortable: false },
  { label: 'Email sent?', key: 'invites', sortable: true },
  { label: 'Registered', key: 'registered', sortable: true }
];

class People extends Component {
  componentDidMount = () => {
    this.props.clearAllFilters();
    this.props.getUsers();
  };

  componentWillUnmount() {
    this.props.actions.hide();
  }

  render() {
    const {
      actions,
      filteredData,
      team,
      dialogContent,
      isLoading,
      sendRegistrationEmail
    } = this.props;

    const teamActions = {
      hide: actions.hide,
      show: actions.show,
      hideDisable: actions.hideDisable,
      showDisable: actions.showDisable,
      sendEmail: sendRegistrationEmail
    };

    const filterGuard = () => {
      if (!filteredData) {
        return false;
      } else if (filteredData && filteredData.length > 0 && 'contactString' in filteredData[0]) {
        return true;
      } else if (filteredData && filteredData.length === 0) {
        return true;
      }
    };

    return (
      <Fragment>
        <div>
          <Table
            title='People'
            labelKeys={peopleListLabelKeys}
            isLoading={isLoading}
            orgs={this.props.orgs}
            data={filterGuard() ? filteredData : team}
            actions={teamActions}
          />
        </div>
        <OverviewDialog
          data={dialogContent}
          visible={this.props.dialogVisible}
          onHide={teamActions.hide}
          title={this.props.dialogTitle}
        />
        <DeactivateModal
          visible={this.props.disableModalVisible}
          onHide={teamActions.hideDisable}
          deactivateUser={this.props.deactivateUser}
          title='PERSON'
        />
        <LoadingSpinner show={isLoading} delay={650} />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  team: state.users.data,
  dialogVisible: state.wizard.visible,
  dialogContent: state.wizard.data,
  dialogTitle: state.wizard.title,
  filteredData: state.filter.peopleFilteredData,
  isLoading: state.users.isLoading || state.organizations.isLoading,
  disableModalVisible: state.dialog.visible
});

export default connect(mapStateToProps, {
  clearAllFilters,
  getUsers,
  sendRegistrationEmail,
  deactivateUser
})(People);



// WEBPACK FOOTER //
// ./src/containers/People/People.jsx